import { map } from 'rxjs/operators';
import { of } from 'rxjs';
import { Injectable } from "@angular/core";
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { TenantService } from './tenant.service';

@Injectable({ providedIn: 'root' })
export class SelfSignupEnabledGuard implements CanActivate {
    tenant: any;

    constructor(private tenantService: TenantService) {}

    canActivate = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
        return (this.tenant ? of(this.tenant) : this.tenantService.getUnauthTenantInfo())
        .pipe(
            map(tenant => {
                this.tenant = tenant;
                return this.tenant.settings.selfSignupConfiguration === 'true';
            })
        );
    };
}
